import { gate } from 'hub-http/gates';
export const GATES = {
  USER_SENT_REMINDER_NOTIFICATION: gate('ProductApprovals:UserSentReminderNotification'),
  APPROVAL_DASHBOARD: gate('ProductApprovals::Dashboard')
};